import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
const LINK_FOCUS = 'rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sol';
export function Footer() {
  return <footer className="border-t-4 border-sol bg-navy-dark pb-16" data-id="element-71" data-mp="32pfci3q053uh">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-72" data-mp="36ooaxlvzlpwd">
        <p className="text-xs leading-snug text-white" data-id="element-73" data-mp="3ufa4671c15mb">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[11px] leading-snug text-white/70" data-id="element-74" data-mp="398xsbsbb070">
          {PRODUCT_NAME}™ es un producto educativo. Está diseñado para
          facilitar el aprendizaje de vocabulario, expresiones y conversaciones
          prácticas en inglés. No garantiza fluidez, resultados específicos ni
          sustituye documentación migratoria, asesoramiento profesional,
          información oficial de viaje o asistencia de emergencia.
        </p>
        <p className="mt-1.5 text-xs text-white" data-id="element-75" data-mp="2ew700loelk6h">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className={`font-semibold text-sol transition-colors duration-150 ease-out hover:text-white ${LINK_FOCUS}`} data-id="element-76" data-mp="3labqfslx60os">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-xs text-white" data-id="element-77" data-mp="3q8mzi14e475y">
          <a href="#terminos" className={`transition-colors duration-150 ease-out hover:text-sol ${LINK_FOCUS}`} data-id="element-78" data-mp="817cg38o1ksh">
            Términos y Condiciones
          </a>
          <span className="text-sol" aria-hidden="true" data-id="element-79" data-mp="hs1xj4a6eecc">•</span>
          <a href="#privacidad" className={`transition-colors duration-150 ease-out hover:text-sol ${LINK_FOCUS}`} data-id="element-80" data-mp="ctgxb4uxbunw">
            Política de Privacidad
          </a>
          <span className="text-sol" aria-hidden="true" data-id="element-81" data-mp="mspqhvhyt597">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className={`transition-colors duration-150 ease-out hover:text-sol ${LINK_FOCUS}`} data-id="element-82" data-mp="tv4n215bx24h">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}